// src/api/treasury.api.js
import axiosInstance from './axiosInstance';

export const fetchTreasury = () => axiosInstance.get('/treasury/');
export const depositFunds = (payload) => axiosInstance.post('/treasury/deposit/', payload);
export const withdrawFunds = (payload) => axiosInstance.post('/treasury/withdraw/', payload);
export const adjustBalance = (payload) => axiosInstance.post('/treasury/adjust-balance/', payload);

export const fetchTreasuryTransactions = (params) => axiosInstance.get('/treasury-transactions/', { params });
export const fetchTreasuryReport = (params) => axiosInstance.get('/treasury-report/', { params });

export const fetchTreasuryAudits = (params) => axiosInstance.get('/treasury-audits/', { params });
export const createTreasuryAudit = (payload) => axiosInstance.post('/treasury-audits/', payload);
export const deleteTreasuryTransaction = (id) =>
  axiosInstance.delete(`/treasury-transactions/${id}/`);
